import gsap from 'gsap';

import Component from '../base/component';

import { data } from '../base/dom-utils';

export default class ParallaxScroll extends Component {

    constructor(el, opts) {

        super(el, opts);

        if (this.options.scrollbarInstance === null || this.options.scrollbarInstance === undefined) {
            return false;
        }

        this._scrollTop = 0;

        this.setScrollTop = this.setScrollTop.bind(this);
        this.handleScroll = this.handleScroll.bind(this);

        this.setScrollTop();

        this._speed = data('speed', this.$el) !== '' ? parseFloat(data('speed', this.$el)) : this.options.speed;

        this._max = parseInt(this._elementHeight * this._speed, 10);

        this._delta = Math.abs(this._max) * 1.2;

        this._initialValue = data('y', this.$el) !== '' ? parseInt(data('y', this.$el), 10) : 0;

    }

    beforeInit() {
        window.addEventListener('resize', this.setScrollTop);
        this.options.scrollbarInstance.addListener(this.handleScroll);
    }

    handleScroll() {

        this._windowScrollTop = this.options.scrollbarInstance.scrollTop;
        this._windowHeight = window.innerHeight;

        const val = ((this.getElementViewportPercentage() * this._delta) / 100) - this._max;

        gsap.to(this.$el, 0.4, {
            y: this._initialValue - val,
            force3D: false,
            ease: 'easeOut'
        });

    }

    getElementViewportPercentage() {
        return parseInt(100 * ((this._windowScrollTop + this._windowHeight) - this._scrollTop) / this._windowHeight, 10);
    }

    setScrollTop() {
        this._scrollTop = this.$el.getBoundingClientRect().top;
        this._elementHeight = this.$el.offsetHeight;
    }

    destroy() {
        window.removeEventListener('resize', this.setScrollTop);
        return super.destroy();
    }

    getDefaultOptions() {
        return {
            speed: 0.2,
            type: 'translate',
            deltaMax: 40,
            scrollbarInstance: null
        }
    }

}


/** WEBPACK FOOTER **
 ** ./components/parallax-scroll.js
 **/